<template>
  <commercial-banner-slider v-if="commercial" :items="items" />
  <banner-carousel v-else :items="items" />
</template>

<script>
import BannerCarousel from "@/components/BannerCarousel.vue";
import CommercialBannerSlider from "@/components/CommercialBannerSlider.vue";

export default {
  name: "HomeBannerRail",
  components: { BannerCarousel, CommercialBannerSlider },
  props: {
    items: { type: Array, default: () => [] },
    commercial: { type: Boolean, default: false },
  },
};
</script>
